/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * macweb API
 * OpenAPI spec version: 0.4.45
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  ErrorResponse,
  MailSendRequest,
  NotificationSendRequest,
  NotificationSendResponse
} from '.././model';

import { customInstance } from '../../orvalMutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Send email
 */
export const mailSend = (
    mailSendRequest: MailSendRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/mail/send`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: mailSendRequest, signal
    },
      options);
    }
  


export const getMailSendMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mailSend>>, TError,{data: MailSendRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof mailSend>>, TError,{data: MailSendRequest}, TContext> => {

const mutationKey = ['mailSend'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mailSend>>, {data: MailSendRequest}> = (props) => {
          const {data} = props ?? {};

          return  mailSend(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MailSendMutationResult = NonNullable<Awaited<ReturnType<typeof mailSend>>>
    export type MailSendMutationBody = MailSendRequest
    export type MailSendMutationError = ErrorResponse

    /**
 * @summary Send email
 */
export const useMailSend = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mailSend>>, TError,{data: MailSendRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof mailSend>>,
        TError,
        {data: MailSendRequest},
        TContext
      > => {

      const mutationOptions = getMailSendMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Send notification via multiple channels
 */
export const notificationsSend = (
    notificationSendRequest: NotificationSendRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<NotificationSendResponse>(
      {url: `/api/notifications/send`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: notificationSendRequest, signal
    },
      options);
    }
  


export const getNotificationsSendMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsSend>>, TError,{data: NotificationSendRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof notificationsSend>>, TError,{data: NotificationSendRequest}, TContext> => {

const mutationKey = ['notificationsSend'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationsSend>>, {data: NotificationSendRequest}> = (props) => {
          const {data} = props ?? {};

          return  notificationsSend(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NotificationsSendMutationResult = NonNullable<Awaited<ReturnType<typeof notificationsSend>>>
    export type NotificationsSendMutationBody = NotificationSendRequest
    export type NotificationsSendMutationError = ErrorResponse

    /**
 * @summary Send notification via multiple channels
 */
export const useNotificationsSend = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsSend>>, TError,{data: NotificationSendRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notificationsSend>>,
        TError,
        {data: NotificationSendRequest},
        TContext
      > => {

      const mutationOptions = getNotificationsSendMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    